import { DOM, classes, matchMediaMax, breakpoints } from '../const';

const { isActive } = classes;
const { md } = breakpoints;
const { $hbody } = DOM;

const $$jumpMarksContainers = $('.js-jump-mark-container');
const $$jumpMarks = $('.js-jump-mark');
const $$marksAcc = $('.js-marks-acc');


const initAcc = $el => {
  let accOpen = false;
  const $btn = $el.find('.js-marks-acc-btn');
  const $contnent = $el.find('.js-marks-acc-content');

  const checkAcc = () => {

    if (matchMediaMax(md - 1)) {
      if (accOpen) {
        $contnent.show();
      } else {
        $contnent.hide();
      }
    } else {
      $contnent.show();
    }
  };

  $btn.click(event => {
    event.preventDefault();
    accOpen = !accOpen;
    if (accOpen) {
      $btn.addClass(isActive);
      $contnent.slideDown();
    } else {
      $btn.removeClass(isActive);
      $contnent.slideUp();
    }
  });


  $el.find('.js-jump-mark, .js-map-mark').click(() => {
    if (matchMediaMax(md - 1)) {
      accOpen = false;
      $btn.removeClass(isActive);
      $contnent.slideUp();
    }
  });

  checkAcc();
  $(window).resize(checkAcc);
};

const checkMarks = () => {
  $$jumpMarksContainers.each((i, el) => {
    const $$marks = $(el).find('.js-jump-mark');

    $$marks.each((j, mark) => {
      const id = $(mark).attr('href');
      const $target = $(id).first();
      if (!$target.length) return;

      const windowTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const targetHeight = $target.outerHeight();
      const targetTop = $target.offset().top;

      let conditionTop = false;
      let conditionBottom = false;

      if (targetHeight < windowHeight) {
        conditionTop = targetTop - windowTop < windowHeight / 2;
        conditionBottom = true;
      } else {
        conditionTop = windowTop >= targetTop;
        conditionBottom = windowTop <= targetTop + targetHeight;
      }

      if (conditionTop && conditionBottom) {
        $$marks.removeClass(isActive);

        $(mark).addClass(isActive);
      }

    });
  });
};

const jumpMarks = () => {

  $$jumpMarks.each((i, el) => {
    const id = $(el).attr('href');
     const $target = $(id).first();
     if (!$target.length) return;

    $(el).click(event => {
      event.preventDefault();

      const windowHeight = $(window).height();
      const targetHeight = $target.outerHeight();
      const targetTop = $target.offset().top;

      let scrollTo = 0;
      let topOffset =  targetTop;

      if (matchMediaMax(md - 1)) {
        const $container = $(el).closest('.js-jump-mark-container');
        topOffset = targetTop - $(el).outerHeight() - parseInt($container.css('padding-top'), 10) - 20;
      }

      scrollTo = targetHeight + 100 > windowHeight ?  topOffset : targetTop - (windowHeight -  targetHeight) / 2;

      $hbody.animate({
        scrollTop: scrollTo
      }, 1000);
    });
  });
  checkMarks();
  $(window).scroll(checkMarks);
  $(window).resize(checkMarks);

  $$marksAcc.each((i, el) => {
    initAcc($(el));
  });
};

export default jumpMarks;
